<template>
    <el-dialog title="教程内容维护" :visible="visible" :show="show" width="50%" :close-on-click-modal="false"
               @close="close" custom-class="module-dialog">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
            <el-form-item label="类型" class="input" prop="type" >
                <el-radio v-model="ruleForm.type" label="1" value="1">WEB端教程</el-radio>
                <el-radio v-model="ruleForm.type" label="2" value="2">APP端教程</el-radio>
                <el-radio v-model="ruleForm.type" label="3" value="3">微信小程序教程</el-radio>
            </el-form-item>
            <el-form-item label="教程标题" class="input" prop="title" >
                <el-input v-model="ruleForm.title" autocomplete="off" placeholder="请输入教程标题" ></el-input>
            </el-form-item>
            <el-form-item label="教程图片" prop="imagePath" v-if="this.rowData.type!='info'">
                <el-upload
                        ref="couseImg"
                        :action="fileUploadUrl"
                        list-type="picture-card"
                        :headers="myHeaders"
                        :on-exceed="handleExceedImg"
                        :on-success="handleUploadSuccessImg"
                        :before-upload="beforeUploadImg"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
                <!--<el-upload
                        class="avatar-uploader"
                        :action="fileUploadUrl"
                        :show-file-list="false"
                        :on-success="handleUploadSuccessImg"
                        :before-upload="beforeUploadImg">
                    <img v-if="imagePath" :src="url+'/upload/'+this.rowData.imagePath" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>-->
                </el-form-item>
            <el-form-item label="排序" prop="sortIndex">
                <el-input-number :controls="false" v-model="ruleForm.sortIndex" placeholder="请输入顺序" style="width:80%"></el-input-number>
            </el-form-item>
            <el-form-item label="教程内容" prop="context">
                <textarea v-model="ruleForm.context" rows="5" cols="50" style="width:80%"></textarea>
            </el-form-item>
            <el-form-item label="视频缩略图" prop="videoThumbnail" v-if="this.rowData.type!='info'">

                <el-upload
                        ref="imgUpload"
                        :action="fileUploadUrl"
                        list-type="picture-card"
                        :headers="myHeaders"
                        :on-exceed="handleExceedImg"
                        :on-success="handleUploadSuccessVideoThumbnail"
                        :before-upload="beforeUploadImg"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="视频" prop="videoPath" v-if="this.rowData.type!='info'">
                <!--<el-upload
                        ref="upload"
                        :action="fileUploadUrl"
                        :headers="myHeaders"
                        :on-exceed="handleExceed"
                        :on-success="handleUploadSuccess"
                        :before-upload="beforeUpload"
                        accept="video/*"
                >
                    <i class="el-icon-plus"></i>
                </el-upload>-->
                <el-upload
                        ref="video"
                        class="upload-demo"
                        :action="fileUploadUrl"
                        :on-success="handleUploadSuccess"
                        :file-list="fileList">
                    <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item label="视频" prop="videoPath" v-if="this.rowData.type=='info'">
                <video controls="controls" :src="url+'/upload/'+this.rowData.videoPath" style="width:600px;height:auto"></video>
            </el-form-item>
            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn" type="primary" v-show="updateBtn" @click="commit()">保存</el-button>
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'addOrUpdate',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                }
            },
            rowData(){

                this.$http({
                    url: "course/info/"+this.rowData.id,
                    method: "get",
                }).then(({data}) => {
                    if (data.data!=null){
                        this.ruleForm = data.data;
                    }
                });
                if (this.rowData.type=='info'){
                    this.updateBtn = false
                }
            },
        },
        mounted(){
            this.myHeaders= {
                'Token':this.$storage.get("Token")
            }
        },
        data(){
            return{
                updateBtn:true,
                url:base.get().url,
                fileUploadUrl:base.get().fileUploadUrl,
                visible:false,
                ruleForm:{
                    title:'',
                    context:'',
                    sortIndex:'',
                    type:'',
                    videoPath:'',
                    videoThumbnail:'',
                },
                rules:{
                    title:[{ required: true, message: '请输入教程标题', trigger: 'blur' }],
                    videoPath:[{ required: true, message: '请上传教程视频', trigger: 'blur' }],
                    sortIndex:[{ required: true, message: '请输入顺序', trigger: 'blur' }],
                    type:[{ required: true, message: '请选择此教程类型', trigger: 'blur' }],
                },
                myHeaders:{},
                url:base.get().url,
            }
        },
        methods:{
            close(){
                this.updateBtn = true;
                this.$refs['ruleForm'].resetFields();
                this.$refs['imgUpload'].clearFiles();
                this.$refs['couseImg'].clearFiles();
                this.$refs['video'].clearFiles();
                this.$emit("listenToChildEvent",false);
            },
            commit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url:  this.ruleForm.id==''|| this.ruleForm.id==undefined?this.url+`course/`+"save":this.url+`course/`+"update",
                            method: "post",
                            data:this.ruleForm
                        }).then(({ data }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: "保存成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.close();
                                    }
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    }
                });
            },
            // 上传文件成功后执行
            handleUploadSuccess(res, file, fileList) {
                this.ruleForm.videoPath = file.response.file;
            }
            ,// 上传文件成功后执行
            handleUploadSuccessVideoThumbnail(res, file, fileList) {
                this.ruleForm.videoThumbnail = file.response.file;
            },
            // 上传文件成功后执行
            handleUploadSuccessImg(res, file, fileList) {
                this.ruleForm.imgPath = file.response.file;
            },
            handleExceed(files, fileList) {
                this.$message.warning(`最多上传${this.limit}个视频`);
            },
            handleExceedImg(files, fileList) {
                this.$message.warning(`最多上传${this.limit}个图片`);
            },
            beforeUpload(file) {
                const isVideo = file.type === 'video/mp4' || file.type === 'video/ogg' || file.type === 'video/flv' || file.type === 'video/avi' || file.type === 'video/wmv' || file.type === 'video/rmvb';
                if (!isVideo) {
                    this.$message.error('只能上传视频文件!');
                }
                return isVideo;
            },
            beforeUploadImg(file){
                const isImg = file.type === 'image/jpeg' || file.type === 'image/png';
                if (!isImg) {
                    this.$message.error('只能上传图片!');
                }
            }

        }
    }
</script>
<style lang="scss">
    .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }

    .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }

    .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
    }

    .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }

    .detail-form-content .el-form-item {
        margin-bottom: 20px;
    }

    .detail-form-content .el-form-item__label {
        font-weight: 600;
        color: #303133;
        font-size: 14px;
    }

    .detail-form-content .el-form-item__content {
        line-height: normal;
    }

    .detail-form-content .el-input__inner {
        border-radius: 4px;
        border-color: #dcdfe6;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-input__inner:focus {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-select {
        width: 100%;
    }

    .detail-form-content .el-upload-list--picture-card .el-upload-list__item,
    .detail-form-content .el-upload--picture-card {
        width: 120px;
        height: 120px;
        line-height: 126px;
        border-radius: 6px;
        border: 1px dashed #c0ccda;
        transition: border-color 0.25s;
    }

    .detail-form-content .el-upload--picture-card:hover {
        border-color: var(--publicMainColor);
    }

    .detail-form-content .el-upload--picture-card i {
        font-size: 28px;
        color: #8c939d;
    }

    .detail-form-content .el-upload--picture-card:hover i {
        color: var(--publicMainColor);
    }

    .detail-form-content .el-input.is-disabled .el-input__inner {
        background-color: #f5f7fa;
        color: #909399;
        cursor: not-allowed;
    }

    .detail-form-content .form-footer {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding-top: 16px;
        border-top: 1px solid #f0f0f0;
        margin-top: 8px;
    }

    .detail-form-content .form-footer .el-button {
        min-width: 100px;
        border-radius: 4px;
    }

    .detail-form-content .form-footer .el-button--primary {
        background-color: var(--publicMainColor);
        border-color: var(--publicMainColor);
    }

    .detail-form-content .form-footer .el-button--primary:hover {
        background-color: #2b5797;
        border-color: #2b5797;
    }

    .detail-form-content .form-footer .el-button--default:hover {
        color: var(--publicMainColor);
        border-color: rgba(58, 110, 165, 0.3);
        background-color: rgba(58, 110, 165, 0.06);
    }
</style>